module.exports = __webpack_public_path__ + "img/about1.41448990.png";